/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
// image
import VocPopupImg from '@assets/images/voc/voc-popup/voc-popup-img.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { isMobile } from 'react-device-detect'
import { VocModalWrap } from './index.style'
import PopupUtils from '@utils/popup-utils'
import { loadOrReload } from '@utils/utils'

const VocPopup: React.FC = props => {
  const { globalStore, vocStore } = useRootStore()
  const { visibleVocPopup } = globalStore

  const onCloseModal = async () => {
    await vocStore.attendVoc()
    globalStore.setVisibleVocPopup(false)
  }

  const onClickGoVocPage = () => {
    globalStore.setVisibleVocPopup(false)
    globalStore.cleanVisibleModalList()
    if (isMobile) {
      loadOrReload('/voc-page')
    } else {
      // globalStore.addGeneralPopupProperties(<VocPage />, '고객의 소리', { className: 'voc-page', isScroll: true })
      PopupUtils.showVocPagePopup()
    }
  }

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleVocPopup}
        maskClosable={false}
        onClose={onCloseModal}
        wrapClassName="voc-popup"
        className="event"
      >
        <VocModalWrap>
          <img src={VocPopupImg} alt="" className="voc-modal-img"/>
          <Button className="voc-modal-close-btn" onClick={onCloseModal}/>
          <p className="voc-modal-txt">
            <span className="voc-modal-txt--point-color">당신의 한마디</span>가 더 좋은 게임을 만듭니다!
            <br/>
            다음 챌린저는당신~!
          </p>
          <Button secondary className="voc-modal-btn" onClick={onClickGoVocPage}>
            참여하러가기
          </Button>
        </VocModalWrap>
        <ModalBg className="modal-bg"/>
      </Modal>
    </Fragment>
  )
}

export default observer(VocPopup)
